<app-ce-review-task-content [task]="clientReferralTask">
  <div class="col">
    <div><strong>CLIENT REFERRAL DATE</strong></div>
    {{ capture.clientReferralVerification?.referralDate | date: 'MM/dd/yyyy' }}
  </div>
  <div class="col">
    @if (clientReferralTask.mostRecentSubmission) {
      <div><strong>TASK RESPONSE</strong></div>
      <div>{{ keyedChoiceOptions[clientReferralTask.mostRecentSubmission.choice].label }}</div>
      <ul class="py-1 ps-4 mb-0">
        @for (reason of clientReferralTask.mostRecentSubmission.choiceReasons; track reason; let i = $index) {
          <li>
            <app-client-referral-task-option-reason
              [patient]="capture.patient"
              [provider]="capture.provider"
              [reason]="reason"
              [taskSubmission]="clientReferralTask.mostRecentSubmission" />
          </li>
        }
      </ul>
    }
  </div>
</app-ce-review-task-content>
